window.dbs = window.dbs || {}

dbs.events = function () {
  const self = this
  self.events = {}

  self.subscribe = function (eventName, callback) {
    self.events[eventName] = self.events[eventName] || []
    self.events[eventName].push(callback)
  }

  self.emit = function (eventName, data, log) {
    if (process.env.NODE_ENV === 'development' && log) {
      console.log('Event: ' + eventName, data)
    }

    const evt = self.events[eventName]
    if (evt) {
      for (let i = 0; i < evt.length; i++) {
        evt[i].call(null, data)
      }
    }
  }
}

window.dbs.globalEvents = new dbs.events()
